var React = require('react');

function IconLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.8692 6.6496L9.15878 1.06092C9.04949 0.928149 8.85276 1.01264 8.85276 1.1937V3.2457C1.28992 3.64403 0.120525 10.0052 0.000306345 13.7229C-0.0106226 13.9764 0.27353 14.0971 0.426536 13.9161C3.31178 10.5484 6.17517 10.488 8.85276 10.5001V12.709C8.85276 12.9022 9.07134 12.9987 9.19156 12.8539L13.8692 7.31348C14.0331 7.13242 14.0331 6.83066 13.8692 6.6496Z","fill":"#222222"}));
}

IconLink.defaultProps = {"width":"20","height":"18","viewBox":"0 0 13 15","fill":"none"};

module.exports = IconLink;

IconLink.default = IconLink;
